import { ErrorCodeType } from "application/models/IError";
import { getGlobalAddLog } from "Infrastructure/repositories/appInsights/AppInsights";
import { IEventRepository } from "modules/events/domain/interfaces/IEventRepository";
import { IEvent } from "modules/events/domain/models/IEvent";
import { GetError } from "utils/GetError";

const addLog = getGlobalAddLog();

export const GetEventsUseCase = async (
	eventRepository: IEventRepository,
	localClienteId: string
): Promise<IEvent[] | undefined> => {
	try {
		return await eventRepository.getEventsByLocalClienteId(localClienteId);
	} catch (error) {
		addLog && addLog("[ERROR] GetEventsUseCase", { localClienteId, error });
		GetError(
			error,
			"GetEventsUseCase",
			"GetEventsUseCase",
			"Falha ao buscar eventos",
			ErrorCodeType.GENERAL
		);
	}
};
